import { Box, Flex, Image } from '@chakra-ui/react'
import Ranking1Svg from '@images/ranking_1.svg'
import Ranking2Svg from '@images/ranking_2.svg'
import Ranking3Svg from '@images/ranking_3.svg'
import { buildAssetUrlString } from '@!/Util/buildAssetUrlString'

export const RankingCrown = ({ ranking }) => {
  const getRankingImage = (ranking) => {
    switch (ranking) {
      case 1:
        return Ranking1Svg
      case 2:
        return Ranking2Svg
      case 3:
        return Ranking3Svg
      default:
        return null
    }
  }

  return (
    <Flex position="relative" w="100%">
      <Box position="absolute" zIndex="1" bottom="25px" left="-8px">
        {ranking <= 3 ? (
          <Box filter="drop-shadow(2px 2px 3px rgba(0, 0, 0, 0.2))">
            <Image src={buildAssetUrlString(getRankingImage(ranking))} alt="Ranking Crown" fit="contain" />
          </Box>
        ) : (
          <Flex
            w="33px"
            h="33px"
            bgColor="bg.primary"
            border="0.5px solid black"
            borderRadius="4px"
            boxShadow="2px 2px 3px rgba(0, 0, 0, 0.2)"
            justifyContent="center"
            mx={1}
          >
            <Flex position="absolute" fontSize="lg" fontWeight="black" color="label.black" justifyContent="center" alignItems="center" w="100%" h="100%">
              {ranking}
            </Flex>
          </Flex>
        )}
      </Box>
    </Flex>
  )
}
